<template>
  <div class="index" v-cloak>
    <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin"
    >
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>
    <div class="home_top">
      <div class="header acea-row row-middle" v-if="false">
        <div style="width:10vw;"></div>
        <div class="logo"><img :src="logoUrl" /></div>
      </div>
      <div class="slider-banner banner" v-if="navIndex == 0">
        <swiper :options="swiperOption" v-if="banner.length > 0">
          <swiper-slide v-for="(item, index) in banner" :key="index">
            <img :src="item.pic" />
          </swiper-slide>
          <div
            class="swiper-pagination paginationBanner"
            slot="pagination"
          ></div>
        </swiper>
      </div>
    </div>
    <div v-show="navIndex == 0">
      <div class="nav acea-row" v-if="menus.length">
        <router-link
          :to="item.wap_url ? item.wap_url : ''"
          class="item"
          v-for="(item, index) in menus"
          :key="index"
        >
          <div class="pictrue"><img v-lazy="item.pic" alt="img" /></div>
          <div>{{ item.name }}</div>
        </router-link>
      </div>
      <!-- <div class="newOrder">
        昨日总盒数：<span>{{ new_order_num }}</span>
      </div> -->
      <div class="news acea-row row-between-wrapper" v-if="roll.length">
        <div class="pictrue"><img src="@assets/images/notice.png" /></div>
        <div class="swiper-no-swiping new-banner">
          <swiper
            class="swiper-wrapper"
            :options="swiperRoll"
            v-if="roll.length > 0"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in roll"
              :key="index"
            >
              <router-link
                :to="item.wap_url ? item.wap_url : ''"
                class="acea-row row-between-wrapper"
              >
                <div class="text acea-row row-between-wrapper">
                  <div class="label" v-if="item.show === '是'">最新</div>
                  <div class="newsTitle line1">{{ item.info }}</div>
                </div>
                <div class="iconfont icon-xiangyou"></div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 活动专区 -->
      <div
        class="specialArea acea-row row-between-wrapper"
        v-if="activityOne.wap_link !== undefined || activity.length"
      >
        <!-- <div class="specialArea acea-row row-between-wrapper" v-if="false"> -->
        <router-link
          :to="activityOne.wap_link ? activityOne.wap_link : ''"
          v-if="activityOne.wap_link !== undefined"
          class="assemble"
        >
          <img v-lazy="activityOne.pic" alt="img" />
          <div class="text">
            <div class="name">{{ activityOne.title }}</div>
            <div class="infor">{{ activityOne.info }}</div>
          </div>
        </router-link>
        <div class="list acea-row row-column-between">
          <router-link
            :to="item.wap_link ? item.wap_link : ''"
            class="item"
            v-for="(item, index) in activity"
            :key="index"
          >
            <img v-lazy="item.pic" alt="img" />
            <div class="text">
              <div class="name">{{ item.title }}</div>
              <div class="infor">{{ item.info }}</div>
            </div>
          </router-link>
        </div>
      </div>
      <!-- 限时抢购 -->
      <Skill-area :timeList="timeList" :isshow="showskill"></Skill-area>
      <!-- 快速选择 -->
      <div class="wrapper" v-if="info.fastList.length > 0">
        <div class="title acea-row row-between-wrapper">
          <div class="text">
            <div class="name line1">快速选择</div>
            <div class="line1">{{ info.fastInfo }}</div>
          </div>
          <!-- <router-link :to="'/category'" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link> -->
        </div>
        <div class="scroll-product">
          <swiper class="swiper-wrapper" :options="swiperScroll">
            <swiper-slide
              v-for="(item, index) in info.fastList"
              :key="index"
              class="swiper-slide"
            >
              <router-link
                :to="{
                  path: '/goods_list',
                  query: { id: item.id, title: item.cate_name }
                }"
              >
                <div class="img-box">
                  <img v-lazy="item.pic" alt="img" />
                </div>
                <div class="pro-info line1">{{ item.cate_name }}</div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="wrapper" v-if="info.firstList.length > 0">
        <div class="first_title">
          <div class="text">
            <img src="@assets/images/first_title.png" alt="" />
          </div>
          <!-- <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link> -->
        </div>
        <div class="newProducts">
          <swiper class="swiper-wrapper" :options="swiperProducts">
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in info.firstList"
              :key="index"
            >
              <div>
                <div class="img-box">
                  <img v-lazy="item.image" :src="item.image" alt="img" />
                  <span
                    class="pictrue_log_medium pictrue_log_class"
                    v-if="item.activity && item.activity.type === '1'"
                    >秒杀</span
                  >
                  <span
                    class="pictrue_log_medium pictrue_log_class"
                    v-if="item.activity && item.activity.type === '2'"
                    >砍价</span
                  >
                  <span
                    class="pictrue_log_medium pictrue_log_class"
                    v-if="item.activity && item.activity.type === '3'"
                    >拼团</span
                  >
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="goodsinfo">
            <div class="pro-info line1">
              {{ firstList_store_name || info.firstList[0].store_name }}
            </div>
            <div class="money font-color-red">
              ￥{{ firstList_price || info.firstList[0].price }}
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="info.bastList.length > 0">
        <div class="boutique_title">
          <div class="text">
            <img src="@assets/images/boutique_title.png" alt="" />
          </div>
          <!-- <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link> -->
        </div>
        <div class="slider-banner botbanner">
          <swiper class="swiper-wrapper" :options="swiperBoutique">
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in info.bastBanner"
              :key="index"
            >
              <router-link :to="item.wap_link ? item.wap_link : ''"
                ><img :src="item.img"
              /></router-link>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination paginationBoutique"></div>
        </div>
        <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
      </div>
      <div class="hotList" v-if="likeInfo">
        <div class="hots_title">
          <div class="text">
            <img src="@assets/images/hot_title.png" alt="" />
          </div>
          <!-- <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link> -->
        </div>
        <div class="slider-banner hotbanner">
          <swiper class="swiper-wrapper" :options="hotbanner">
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in likeInfo"
              :key="index"
            >
              <router-link :to="{ path: '/detail/' + item.id }">
                <img :src="item.image" />
                <div class="goodsname line1">{{ item.store_name }}</div>
                <div class="goodsprice">￥{{ item.price }}</div>
              </router-link>
            </swiper-slide>
            <!-- <div class="swiper-pagination paginationHot" slot="pagination"></div> -->
          </swiper>
        </div>
      </div>
      <div v-if="newGoodsBananr">
        <div class="adver">
          <img v-lazy="newGoodsBananr" alt="img" />
        </div>
      </div>
      <div class="wrapper" v-if="benefit.length > 0">
        <!-- <div class="wrapper" v-if="false"> -->
        <div class="promotion_title">
          <div class="text">
            <img src="@assets/images/promotion_title.png" alt="" />
          </div>
          <!-- <router-link :to="'/promotion'" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link> -->
        </div>
      </div>
      <Good-list
        :good-list="benefit"
        v-if="benefit.length > 0"
        :is-sort="false"
        :isRecom="true"
      ></Good-list>
      <!-- <Promotion-good :benefit="benefit"></Promotion-good> -->
      <div class="wrapper" v-if="info.bastList.length > 0">
        <div class="boutique_title">
          <div class="text">
            <img src="@assets/images/boutique_title_more.png" alt="" />
          </div>
        </div>
        <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
      </div>
    </div>
    <div v-if="navIndex != 0">
      <div class="catelist acea-row">
        <a
          href="javascript:;"
          v-for="(item, index) in navList[navIndex - 1].children"
          :key="index"
        >
          <div
            @click="clickcate(item.id, index)"
            class="acea-row"
            :class="cateIndex == index ? 'active' : ''"
          >
            <img :src="item.pic" alt="" />
            <span>{{ item.cate_name }}</span>
          </div>
        </a>
      </div>
      <Good-list :good-list="categoodslist" :is-sort="false"></Good-list>
    </div>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <img class="logo" src="@assets/images/logo3.png" alt="" />
    <router-link to="/news_list?id=3" class="policy-link">
      <div class="policy-title">用户需知</div>
      <div class="policy-desc">为保障供需双方合法权益，依据相关法律法规，就本商城云仓仓储发货、订单管理、产品退换相关事宜请点击<span class="link-text">查看详情</span>。</div>
    </router-link>
    <div style="height:1.6rem;"></div>
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodLists";
import SkillArea from "@components/skillarea";
// import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, follow } from "@api/public";
import { getCategory, getProducts } from "@api/store";
import { getSeckillConfig, getSeckillList } from "@api/activity";
import cookie from "@utils/store/localStorage";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    SkillArea,
    // PromotionGood,
    CouponWindow
  },
  props: {},
  data: function() {
    return {
      new_order_num: "",
      showskill: false, //显示秒杀专区
      skillGoods: [], //秒杀商品
      timeList: [], //秒杀时间列表
      categoodslist: [], //分类商品列表
      firstId: "", //一级分类id
      secondId: "", //二级分类id
      cateIndex: 0, //分类下默认下表
      navList: [], //顶部导航
      navIndex: 0, //分类默认下表
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      hotbanner: {
        pagination: {
          el: ".paginationHot",
          clickable: true
        },
        slidesPerGroup: 3,
        slidesPerView: 3,
        centeredSlidesBounds: true,
        loop: false,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
        centeredSlides: true,
        on: {
          slideChangeTransitionStart: function() {
            vm.firstList_store_name =
              vm.info.firstList[this.realIndex].store_name;
            vm.firstList_price = vm.info.firstList[this.realIndex].price;
          },
          tap: function() {
            const realIndex = this.realIndex;
            vm.goDetail(vm.info.firstList[realIndex]);
          }
        }
      },
      mapKey: "",
      realindex: 0, //
      firstList_store_name: "",
      firstList_price: ""
    };
  },
  created() {
    vm = this;
    this.getcate();
    this.getskill();
  },
  mounted: function() {
    this.getFollow();
    let that = this;
    getHomeData().then(res => {
      that.mapKey = res.data.tengxun_map_key;
      cookie.set(MAPKEY, that.mapKey);
      that.logoUrl = res.data.logoUrl;
      that.newGoodsBananr = res.data.newGoodsBananr;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "new_order_num", res.data.new_order_num);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "likeInfo", res.data.likeInfo);
      that.$set(
        that,
        "lovely",
        res.data.lovely.length ? res.data.lovely[0] : {}
      );
      that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.subscribe = res.data.subscribe;
      if (!that.subscribe && that.followUrl) {
        setTimeout(function() {
          that.followHid = true;
        }, 200);
      } else {
        that.followHid = false;
      }
      if (res.data.site_name) document.title = res.data.site_name;
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
      if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
    });
  },
  methods: {
    // 获取秒杀配置
    getskill() {
      getSeckillConfig()
        .then(res => {
          this.timeList = res.data.seckillTime;
          // this.showskill = res.data.seckillCont;
          this.showskill = false;
          var index = res.data.seckillTimeIndex;
          vm.getskillgoods(vm.timeList[index].id);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取当前秒杀商品
    getskillgoods(id) {
      getSeckillList(id, { page: 1, limit: 20 })
        .then(res => {
          vm.skillGoods = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取分类
    getcate() {
      var that = this;
      getCategory().then(res => {
        that.navList = res.data;
      });
    },
    // 获取分类下的小分类
    changeIndex(id, index) {
      this.firstId = id;
      this.navIndex = index;
      this.cateIndex = 0;
      if (id) {
        console.log(this.navList[index - 1]);
        var secondid = this.navList[index - 1].children[0].id;
        this.getgoodsList(secondid);
      }
    },
    // 获取二级分类下的商品
    clickcate(id, index) {
      this.secondId = id;
      this.cateIndex = index;
      this.getgoodsList(id);
    },
    getgoodsList(id) {
      let obj = {
        page: 1,
        limit: 10,
        sid: id
      };
      getProducts(obj).then(res => {
        console.log(res);
        this.categoodslist = res.data;
      });
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    // 商品详情跳转
    goDetail(item) {
      console.log(item);
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
[v-cloak] {
  display: none;
}
.logo {
  width: 3.2rem;
  height: 3.2rem;
  margin: 0 2.15rem;
}
.policy-link {
  display: block;
  padding: 0.2rem 0.3rem;
  text-decoration: none;
}
.policy-title {
  font-size: 0.28rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 0.1rem;
}
.policy-desc {
  font-size: 0.22rem;
  color: #999;
  line-height: 1.5;
}
.link-text {
  color: #0e98fd;
}
.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}
.keep {
  text-align: center;
}
.home_top {
  .header {
    background: #0e98fd;
  }
  .navList {
    background: linear-gradient(0deg, #0e98fd, #ff6533);
    background: -moz-linear-gradient(0deg, #0e98fd, #ff6533);
    background: -webkit-linear-gradient(0deg, #0e98fd, #ff6533);
    color: #fff;
    overflow: auto;
    width: 100%;
    height: 10vw;
    line-height: 10vw;
    text-align: center;
    flex-wrap: nowrap;
    a {
      height: 10vw;
      color: #fff;
      div {
        width: 20vw;
      }
      .active {
        position: relative;
        &:after {
          content: "";
          position: absolute;
          width: 6vw;
          height: 1vw;
          background-color: #fff;
          bottom: 1vw;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
      }
    }
  }
  .banner {
    width: 100%;
    height: 44vw;
  }
}
.hotbanner {
  width: 92vw;
  margin: 0 4vw;
  .swiper-wrapper {
    padding-bottom: 8vw;
    width: 100%;
    .swiper-slide {
      width: 30vw;
      margin-right: 2vw;
      img {
        width: 30vw;
        height: 30vw;
        border-radius: 2vw;
      }
      .goodsname {
        color: #282828;
        font-size: 3.5vw;
      }
      .goodsprice {
        color: #0e98fd;
        font-size: 4vw;
        font-weight: 600;
      }
    }
  }
}
.hotList,
.wrapper {
  > .hot_title {
    justify-content: center;
    align-items: center;
    height: 15vw;
    img {
      width: 4.5vw;
      height: 3.5vw;
    }
  }
  > .more {
    width: 20vw;
    margin: 0 40vw;
    display: inline-block;
    text-align: center;
    color: #9a9a9a;
    font-size: 3.2vw;
    .iconfont {
      font-size: 2vw;
    }
  }
  .goodslist {
    width: 100vw;
    padding: 0 4vw;
    a {
      width: 28vw;
      margin-bottom: 2vw;
      img {
        width: 28vw;
        height: 28vw;
        border-radius: 2vw;
      }
      .goodsname {
        color: #282828;
        font-size: 3.5vw;
      }
      .goodsprice {
        color: #0e98fd;
        font-size: 4vw;
        font-weight: 600;
      }
    }
    a:nth-child(3n + 2) {
      margin-left: 4vw;
      margin-right: 4vw;
    }
  }
}
</style>

<style lang="scss" scoped>
.promotion_title,
.hots_title,
.boutique_title,
.first_title {
  position: relative;
  width: 100%;
  height: 20vw;
  img {
    position: absolute;
    width: 60%;
    top: 3vw;
    left: 20%;
  }
  a {
    position: absolute;
    right: 4vw;
    top: 7vw;
    font-size: 3vw;
    color: #999;
    .iconfont {
      font-size: 3vw;
    }
  }
}
.botbanner {
  margin-bottom: 4vw;
  padding: 0 4vw;
  height: 35vw;
}
.index {
  .wrapper {
    .newProducts {
      .swiper-slide {
        width: 60vw;
        height: 60vw;
        .img-box {
          img {
            margin-top: 10vw;
            margin-left: 10vw;
            width: 40vw;
            height: 40vw;
          }
        }
      }
      .swiper-slide-active {
        width: 60vw;
        height: 60vw;
        .img-box {
          img {
            margin: 0;
            width: 60vw;
            height: 60vw;
          }
        }
      }
      .goodsinfo {
        width: 60vw;
        margin: 2vw 16vw;
        text-align: center;
      }
    }
  }
}
.newOrder {
  height: 8vw;
  line-height: 8vw;
  padding: 0 4vw;
  font-size: 3.73vw;
  span {
    margin-right: 3vw;
    color: #0e98fd;
    font-size: 5vw;
    font-weight: bold;
  }
}
.catelist {
  width: 100vw;
  flex-wrap: nowrap;
  overflow: auto;
  a {
    div {
      padding: 3vw 0;
      width: 16vw;
      flex-direction: column;
      align-items: center;
      margin-left: 3vw;
      img {
        width: 12vw;
        height: 12vw;
        border-radius: 50%;
      }
      span {
        font-size: 3vw;
      }
    }
    .active {
      color: #0e98fd;
      img {
        border: 1px solid #0e98fd;
      }
    }
  }
}
</style>
